import React from 'react'

const CounterOffer = () => {
    return (
        <div>CounterOffer</div>
    )
}

export default CounterOffer